export const InputMask = {
    Phone: '000-000-0000',
    Date: 'mm/dd/yyyy',
    DateWithoutDay: 'M0/0000',
} as const;
